import { OnInit, EventEmitter, ElementRef, AfterViewInit } from '@angular/core';
import { DetailService } from '../services/detail.service';
import { Action } from '../objects/DetailObject';
import { NgForm } from '@angular/forms';
import { ScrollService } from '../services/scroll.service';
import { ConfirmationService } from '../services/confirmation.service';
import { BsModalService } from 'ngx-bootstrap';
import { ToasterMessageService } from '../services/toaster-message.service';
import { DetailPopupComponent } from '../detail-popup/detail-popup.component';
import { Router } from '@angular/router';
import { ModalControlService } from '../services/modal-control.service';
import { MessagePopupService } from '../services/message-popup.service';
import { WorkspaceService } from '../services/workspace.service';
import { MatRadioButton, MatCheckbox } from '@angular/material';
import { ThemeSettingService } from '../services/theme-setting.service';
import { Globals } from '../objects/Globals';
import { HeaderService } from '../services/header.service';
import { LoginService } from '../services/login.service';
import { AttachmentService } from '../services/attachment.service';
var DetailFormComponent = /** @class */ (function () {
    function DetailFormComponent(router, modalControlService, detailService, scrollService, confirmationService, modalService, toasterMessageService, messagePopupService, workspaceService, themeSettingService, globals, headerService, loginService, attachmentService) {
        this.router = router;
        this.modalControlService = modalControlService;
        this.detailService = detailService;
        this.scrollService = scrollService;
        this.confirmationService = confirmationService;
        this.modalService = modalService;
        this.toasterMessageService = toasterMessageService;
        this.messagePopupService = messagePopupService;
        this.workspaceService = workspaceService;
        this.themeSettingService = themeSettingService;
        this.globals = globals;
        this.headerService = headerService;
        this.loginService = loginService;
        this.attachmentService = attachmentService;
        this.animate = false;
        this.submitted = false;
        this.actions = [];
        this.invalidProperties = [];
        this.isBusy = false;
        this.hidePopup = new EventEmitter();
        this.subForm = new EventEmitter();
        this.detailActions = new EventEmitter();
    }
    Object.defineProperty(DetailFormComponent.prototype, "setSubForm", {
        set: function (obj) {
            var _this = this;
            this.isBusy = true;
            if (!this.autoRefresh)
                this.isBusy = true;
            this.detailService.newFormFromDetail(obj.DetailId, obj.PropertyGroupId).subscribe(function (id) {
                if (id) {
                    _this.componentId = id;
                    _this.getFormDetailCard();
                }
                else {
                    _this.isBusy = false;
                }
            }, function (error) {
                _this.isBusy = false;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailFormComponent.prototype, "setComponentId", {
        set: function (id) {
            this.componentId = id;
            this.isBusy = true;
            this.getFormDetailCard();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailFormComponent.prototype, "triggerFocus", {
        set: function (trigger) {
            if (this.detailForm) {
                this.submitted = true;
                this.saveInvalidProperties();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailFormComponent.prototype, "actionOnDetail", {
        set: function (action) {
            if (action) {
                this.formAction(action, this.subDetailForm, false);
            }
        },
        enumerable: true,
        configurable: true
    });
    DetailFormComponent.prototype.saveInvalidProperties = function () {
        var _this = this;
        this.invalidProperties = [];
        var focus = false;
        this.groups.forEach(function (group) {
            _this.formProperties.filter(function (x) { return x.PropertyGroupId == group.GroupId; }).forEach(function (property) {
                if (_this.subDetailForm.control.get(property.PropertyName)) {
                    if (_this.subDetailForm.control.get(property.PropertyName).invalid) {
                        _this.invalidProperties.push(property.PropertyName);
                        if (!focus) {
                            _this.handlePropertyFocus(property.PropertyName);
                            focus = true;
                        }
                    }
                    else {
                        if (property.PropertyOptions) {
                            var option = property.PropertyOptions.find(function (x) { return x.OptionValue == property.PropertyValue; });
                            if (option) {
                                if (option.OptionRequiresRemarks && option.OptionRemarksMandatory) {
                                    if (!property.PropertyRemarks) {
                                        if (!focus) {
                                            _this.handlePropertyFocus(property.PropertyName, true);
                                            focus = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            });
        });
    };
    DetailFormComponent.prototype.ngOnInit = function () {
        var themes = this.themeSettingService.getTheme();
        this.loaderConfig = themes;
    };
    DetailFormComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.subDetailForm) {
            this.subDetailForm.statusChanges.subscribe(function (result) {
                var obj = { form: _this.subDetailForm, actions: _this.actions };
                _this.subForm.emit(obj);
            });
        }
    };
    DetailFormComponent.prototype.getFormDetailCard = function () {
        var _this = this;
        this.detailService.getFormDetailCard(this.componentId).subscribe(function (result) {
            var tempForm = JSON.parse(result);
            // console.log(JSON.parse(result));
            _this.sortDetailActions(tempForm);
            _this.sortFormProperties(tempForm);
            _this.sortFormPropertyOptions(tempForm);
            _this.sortFormPropertyOptionsGroups(tempForm);
            _this.sortPropertyGroups(tempForm);
            _this.constructMatrixRows(tempForm);
            _this.detailActions.emit(tempForm.Actions);
            _this.detailForm = tempForm;
            _this.currentScore = _this.detailForm.DocTitle;
            _this.maxScore = _this.detailForm.FormMaxScore;
            _this.updatedDate = _this.detailForm.DocSubtitle;
            _this.groups = tempForm.Groups;
            _this.actions = _this.detailForm.Actions;
            _this.formProperties = tempForm.FormProperties;
            _this.isBusy = false;
        });
    };
    DetailFormComponent.prototype.constructMatrixRows = function (tempForm) {
        tempForm.FormProperties.forEach(function (property) {
            if (property.PropertyType == "MATRIX") {
                var count = property.PropertyOptions.map(function (x) { return x.OptionOrder; }).filter(function (value, index, self) { return self.indexOf(value) === index; }).length;
                property.PropertyOptionRows = [];
                for (var k = 1; k < count + 1; k++) {
                    var array = property.PropertyOptions.filter(function (x) { return x.OptionOrder == k; });
                    var newArray = [];
                    property.PropertyOptionGroups.forEach(function (group) {
                        var option = array.find(function (x) { return x.OptionGroup == group.GroupId; });
                        if (option) {
                            newArray.push(option);
                        }
                    });
                    property.PropertyOptionRows.push(newArray);
                }
                property.TransportValueSelection = [];
                var object;
                if (property.PropertyValue) {
                    object = JSON.parse(property.PropertyValue);
                }
                property.PropertyOptionRows.forEach(function (row) {
                    var groupId;
                    if (object) {
                        groupId = object[row[0].OptionValue];
                        if (groupId) {
                            if (row.find(function (x) { return x.OptionGroup == groupId; })) {
                                row.find(function (x) { return x.OptionGroup == groupId; }).OptionIsSelected = true;
                            }
                        }
                    }
                    else {
                        groupId = row[0].OptionValue;
                    }
                    var tvs = {
                        OptionValue: row[0].OptionValue,
                        GroupId: groupId
                    };
                    property.TransportValueSelection.push(tvs);
                });
            }
        });
    };
    DetailFormComponent.prototype.sortDetailActions = function (tempForm) {
        tempForm.Actions = tempForm.Actions.sort(function (a, b) {
            if (a.ActionOrder > b.ActionOrder) {
                return 1;
            }
            else if (a.ActionOrder < b.ActionOrder) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    DetailFormComponent.prototype.sortPropertyGroups = function (tempForm) {
        tempForm.Groups = tempForm.Groups.sort(function (a, b) {
            if (a.GroupOrder > b.GroupOrder) {
                return 1;
            }
            else if (a.GroupOrder < b.GroupOrder) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    DetailFormComponent.prototype.sortFormProperties = function (tempForm) {
        tempForm.FormProperties = tempForm.FormProperties.sort(function (a, b) {
            if (a.PropertyOrder > b.PropertyOrder) {
                return 1;
            }
            else if (a.PropertyOrder < b.PropertyOrder) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    DetailFormComponent.prototype.sortFormPropertyOptions = function (tempForm) {
        tempForm.FormProperties.forEach(function (property) {
            property.PropertyFormattedName = property.PropertyName.replace(/\s/g, "");
            if (property.PropertyOptions) {
                property.PropertyOptions = property.PropertyOptions.sort(function (a, b) {
                    if (a.OptionOrder > b.OptionOrder) {
                        return 1;
                    }
                    else if (a.OptionOrder < b.OptionOrder) {
                        return -1;
                    }
                    else {
                        return 0;
                    }
                });
            }
        });
    };
    DetailFormComponent.prototype.sortFormPropertyOptionsGroups = function (tempForm) {
        tempForm.FormProperties.forEach(function (property) {
            if (property.PropertyOptionGroups) {
                property.PropertyOptionGroups = property.PropertyOptionGroups.sort(function (a, b) {
                    if (a.GroupOrder > b.GroupOrder) {
                        return 1;
                    }
                    else if (a.GroupOrder < b.GroupOrder) {
                        return -1;
                    }
                    else {
                        return 0;
                    }
                });
            }
        });
    };
    DetailFormComponent.prototype.updatePropertyValue = function (property, value, index) {
        if (index === void 0) { index = 0; }
        var newValue = value;
        if (property.PropertyType.toUpperCase() == 'MATRIX') {
            var propOption = property.PropertyOptions.find(function (x) { return x.OptionValue == value.source.value; });
            var json = {};
            property.TransportValueSelection.forEach(function (selection) {
                if (selection.OptionValue == propOption.OptionValue) {
                    selection.GroupId = property.PropertyOptionGroups[index].GroupId; //this should be the new group Id
                }
                json[selection.OptionValue] = selection.GroupId;
            });
            newValue = json;
        }
        var index = this.invalidProperties.indexOf(property.PropertyName);
        if (index > -1)
            this.invalidProperties.splice(index, 1);
        this.detailService.updateFormPropertyValue(this.componentId, property.PropertyName, newValue).subscribe(function (result) {
            //console.log(result);
        });
    };
    DetailFormComponent.prototype.updatePropertyRemarks = function (property, value) {
        this.detailService.updateFormPropertyRemarks(this.componentId, property.PropertyName, value).subscribe(function (result) {
            //console.log(result);
        });
    };
    DetailFormComponent.prototype.updatePropertyBaseRemarks = function (property, value) {
        this.detailService.updateFormBaseRemarks(this.componentId, property.PropertyName, value).subscribe(function (result) {
            console.log(result);
        });
    };
    DetailFormComponent.prototype.formAction = function (action, form, scrollToTop) {
        this.animate = false;
        if (action.TriggersValidation) {
            if (form.valid) {
                // if (scrollToTop){
                //   this.scrollService.triggerScrollTo(this.detailContainer);
                // }
                this.handlePrompt(action);
            }
            else {
                this.submitted = true;
                for (var i in this.detailForm.FormProperties) {
                    if (form.control.get(this.detailForm.FormProperties[i].PropertyName)) {
                        if (form.control.get(this.detailForm.FormProperties[i].PropertyName).invalid) {
                            this.handlePropertyFocus(i);
                            break;
                        }
                    }
                }
            }
        }
        else {
            // if (scrollToTop){
            //   this.scrollService.triggerScrollTo(this.detailContainer);
            // }
            this.handlePrompt(action);
        }
    };
    DetailFormComponent.prototype.handlePropertyFocus = function (name, isRemarks) {
        if (isRemarks === void 0) { isRemarks = false; }
        this.submitted = true;
        this.focusProp = this.formProperties.find(function (x) { return x.PropertyName == name; }).PropertyName;
        if (isRemarks) {
            var el = document.querySelectorAll('.remarks_' + this.focusProp.replace(/\s/g, ''))[0];
            if (el) {
                this.scrollService.triggerScrollTo(el);
            }
        }
        else {
            var element = document.querySelector('#field_' + this.focusProp.replace(/\s/g, ''));
            if (element) {
                this.scrollService.triggerScrollTo(element);
            }
        }
        // switch (this.detailForm.FormProperties[index].PropertyType.toUpperCase()){
        //   case "TEXT":
        //     this.textarea.nativeElement.focus();
        //     break;
        //   case "SINGLESELECT":
        //     this.matRadio.focus();
        //     break;
        //   case "MULTISELECT":
        //       this.matCheckbox.focus();
        //     break;
        //   case "MATRIX":
        //     break;
        // }
    };
    DetailFormComponent.prototype.handlePrompt = function (action) {
        var _this = this;
        if (action.TriggersPrompt) {
            switch (action.PromptType) {
                case "Yes|No":
                    this.confirmationService.confirm("Confirmation", action.PromptMessage, ["CANCEL", "OK"])
                        .subscribe(function (respond) {
                        if (respond.answer == "OK") {
                            _this.detailAction(action);
                        }
                    });
                    break;
                case "TypeToConfirm":
                    this.confirmationService.confirm(action.PromptMessage.split('|')[0], "", ["CANCEL", "OK"], true, action.PromptMessage.split('|')[1], false, action.PromptMessage.split('|')[2])
                        .subscribe(function (respond) {
                        if (respond.answer == "OK") {
                            _this.detailAction(action);
                        }
                    });
                    break;
                case "Preview":
                    this.isBusy = true;
                    this.detailService.checkActionPrompt(this.componentId, action.ActionCommand).subscribe(function (result) {
                        if (result) {
                            _this.isBusy = false;
                            _this.handleWorkflowReturn(result);
                        }
                        else {
                            _this.detailService.getPreview(_this.componentId, action.ActionCommand).subscribe(function (previewId) {
                                _this.isBusy = false;
                                _this.openPopup(previewId, action.PromptMessage.split('|')[0]);
                            });
                        }
                    });
                    break;
            }
        }
        else {
            this.detailAction(action);
        }
    };
    DetailFormComponent.prototype.detailAction = function (action) {
        var _this = this;
        this.animate = false;
        this.detailService.actionFormDetailCard(this.componentId, action.ActionCommand).subscribe(function (result) {
            _this.animate = true;
            _this.handleWorkflowReturn(result);
        });
    };
    DetailFormComponent.prototype.openPopup = function (event, title) {
        var _this = this;
        var config = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-dialog-centered modal-detail',
            initialState: {
                componentId: event,
                title: title
            }
        };
        if (this.modalService.getModalsCount() > 0) {
            document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
        }
        this.modalService.onHide.subscribe(function (reason) {
            if (_this.modalService.getModalsCount() > 0) {
                document.querySelectorAll('.modal.fade').item(_this.modalService.getModalsCount() - 1).classList.add('show');
            }
        });
        this.modalRef = this.modalService.show(DetailPopupComponent, config);
    };
    DetailFormComponent.prototype.handleWorkflowReturn = function (result) {
        var _this = this;
        var command = JSON.parse(result);
        switch (command.ReturnType) {
            case 0:// navigate
                if (command.Arguments) {
                    var path = [];
                    command.Arguments.forEach(function (element) {
                        path.push(element);
                    });
                    this.router.navigate(path);
                }
                break;
            case 1://message
                this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
                break;
            case 2://reload, does nothing, depends on refreshtype
                break;
            case 3://open detail
                this.openPopup(command.Arguments[0], command.Arguments[1]);
                break;
            case 4://message
                var list = ["parent", "all"];
                if (list.filter(function (x) { return x == command.RefreshType; }).length == 0) {
                    // this.hidePopup.emit(true);
                    if (this.modalService.getModalsCount() > 0) {
                        this.modalService.hide(this.modalService.getModalsCount());
                        if (this.modalService.getModalsCount() == 0) {
                            document.body.classList.remove("modal-open");
                        }
                    }
                }
                this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
                if (command.Arguments[2]) {
                    this.openPopup(command.Arguments[2], "");
                }
                break;
            case 5://summary popup
                this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1], "summary", "modal-summary");
                break;
            case 6:
                //comparison
                this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1], "compare");
                break;
            case 7://download file
                this.attachmentService.downloadFile(command.Arguments[0]).subscribe(function (data) {
                    _this.downloadFile(data, command.Arguments[1]);
                });
                break;
            case 8:
                if (this.globals.Session) {
                    if (command.Arguments) {
                        this.handleNavigateAndMessage(command, true);
                    }
                }
                else {
                    this.messagePopupService.popMessage(command.Arguments[0], command.Arguments[1], ["OK"]).subscribe(function (respond) {
                        if (respond.answer == "OK") {
                            _this.handleNavigateAndMessage(command);
                        }
                    });
                }
                break;
            case 9://chart
                break;
            case 10:
                this.isBusy = true;
                this.loginService.goHome().subscribe(function (result) {
                    _this.isBusy = false;
                    _this.globals.Session.HomeUrl = JSON.parse(result);
                    _this.router.navigate(_this.globals.Session.HomeUrl);
                });
                break;
            case 11:
                this.isBusy = true;
                this.modalControlService.launchModal(command.Arguments[0], command.Arguments[1], "form", "modal-form");
                this.isBusy = false;
                break;
        }
        switch (command.RefreshType) {
            case "self":
                this.getFormDetailCard();
                break;
            case "parent":
                this.isBusy = true;
                this.getFormDetailCard();
                this.getEPICParent(false, command.ReturnType);
                break;
            case "all":
                this.getFormDetailCard();
                this.getEPICParent(true, command.ReturnType);
                break;
        }
    };
    DetailFormComponent.prototype.getEPICParent = function (findAllParent, returnType) {
        var _this = this;
        if (findAllParent) {
            this.workspaceService.getAllParentsEPICId(this.componentId).subscribe(function (result) {
                _this.handlePopup(returnType);
                if (result) {
                    var array = JSON.parse(result);
                    array.forEach(function (id) {
                        _this.workspaceService.setParentId(id);
                    });
                }
            }, function (error) {
                _this.handlePopup(returnType);
            });
        }
        else {
            this.workspaceService.getParentEPICId(this.componentId).subscribe(function (result) {
                _this.workspaceService.setParentId(result);
                _this.handlePopup(returnType);
            }, function (error) {
                _this.handlePopup(returnType);
            });
        }
    };
    DetailFormComponent.prototype.handlePopup = function (returnType) {
        if (returnType == 4) {
            this.hidePopup.emit(true);
        }
    };
    DetailFormComponent.prototype.handleNavigateAndMessage = function (command, hasSession) {
        if (hasSession === void 0) { hasSession = false; }
        var path = [];
        var newArgs = command.Arguments.splice(2);
        newArgs.forEach(function (element) {
            path.push(element);
        });
        if (hasSession) {
            // close all popups
            for (var i = 1; i <= this.modalService.getModalsCount(); i++) {
                this.modalService.hide(i);
            }
            document.body.classList.remove("modal-open");
            this.router.navigate(path);
            this.headerService.setSelectedMenu('clearSelected');
            this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
        }
    };
    DetailFormComponent.prototype.downloadFile = function (blob, fileName) {
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(objectUrl);
    };
    return DetailFormComponent;
}());
export { DetailFormComponent };
